var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.313,
    height: 17.241,
    viewBox: "0 0 20.313 17.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20488",
    "data-name": "Group 20488",
    transform: "translate(-6238.3 -130.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20540",
    "data-name": "Path 20540",
    d: "M92.563,60.734h17.731a.324.324,0,0,1,0,.648h-1.31V72.595h1.31a.324.324,0,0,1,0,.648h-9.1l2.465,3.912a.323.323,0,0,1-.546.344l-2.5-3.976-2.5,3.976a.323.323,0,1,1-.546-.344l2.465-3.912h-9.1a.324.324,0,0,1,0-.648h1.31V61.383H90.93a.324.324,0,0,1,0-.648h1.634ZM101.13,68.9a.323.323,0,0,1,.456.458l-.61.609.61.61a.324.324,0,1,1-.458.458l-.61-.61-.61.61a.323.323,0,0,1-.456-.458l.609-.608-.61-.61a.324.324,0,0,1,.458-.458l.61.61.611-.61Zm-3.782-5.508a1.337,1.337,0,0,1,.946,2.283l0,0a1.335,1.335,0,0,1-1.889,0l0,0a1.338,1.338,0,0,1,.947-2.283Zm.489.85a.693.693,0,1,0,.2.489.689.689,0,0,0-.2-.489Zm4.28,1.021a.323.323,0,0,1-.489-.423l1.622-1.872a.323.323,0,0,1,.456-.033l.035.036,1.619,1.869a.323.323,0,1,1-.489.423l-1.053-1.216v3.514a.324.324,0,0,1-.324.324h-7.06V70.1a.324.324,0,0,1-.648,0V67.556a.324.324,0,0,1,.324-.324h7.06v-3.19l-1.053,1.216Zm-9.229,7.337h15.449V61.383H92.887Z",
    transform: "translate(6147.844 69.766)",
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.f4101ae6574b5a406145d98d8b3b3766.svg";
export { ForwardRef as ReactComponent };